import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { PublicLogPage, PublicLogQuery } from '../models/public-log.model';

const EMPTY_PAGE: PublicLogPage = { items: [], totalCount: 0 };

@Injectable({
  providedIn: 'root'
})
export class PublicLogReportService {
  readonly #http = inject(ApiCallingV2Service);
  readonly #baseUrl = `${inject(API_CONFIG).baseUrlV2}/GeneralLog`;

  /**
   * Reads the logs the public pages write. Unlike the other report endpoints this one
   * answers with a real total count, so the paginator needs no probing.
   * `IsValidDateRange` is not sent: it is a read-only property the backend computes itself
   * and rejects the request over, so the range is kept valid on this side instead.
   */
  readPublicLogs(query: PublicLogQuery): Observable<PublicLogPage> {
    let params = new HttpParams().set('PageNumber', query.pageNumber).set('PageSize', query.pageSize);

    if (query.source) {
      params = params.set('Source', query.source);
    }
    if (query.fromDate) {
      params = params.set('FromDate', query.fromDate);
    }
    if (query.toDate) {
      params = params.set('ToDate', query.toDate);
    }

    return this.#http
      .getData<PublicLogPage>(this.#baseUrl, {
        showLoader: false,
        showMessage: false,
        options: { params }
      })
      .pipe(map((response: PublicLogPage | null) => response ?? EMPTY_PAGE));
  }
}
